var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex justify-between items-center flex-wrap mb-1" },
        [
          _c("div", [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.movements_title"))),
            ]),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.movements_hint"))),
            ]),
          ]),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "cancellation_movements.edit",
                  expression: "'cancellation_movements.edit'",
                },
              ],
              attrs: { variant: "primary", disabled: !_vm.selected.length },
              on: { click: _vm.processSelected },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("cancellation.process_selected")) + " "
              ),
              _vm.selected.length
                ? _c("span", [_vm._v("(" + _vm._s(_vm.selected.length) + ")")])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          hide_actions: true,
          route_name: "cancellation_movements",
          order_column: "opened_at",
          direction: "asc",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "select" }),
                _c("vs-th", { key: "protocol" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.protocol"))),
                ]),
                _c("vs-th", { key: "establishment" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.establishment"))),
                ]),
                _c("vs-th", { key: "type" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.movement_type"))),
                ]),
                _c("vs-th", { key: "amount" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.amount"))),
                ]),
                _c("vs-th", { key: "split" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.split"))),
                ]),
                _c("vs-th", { key: "age" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.open_since"))),
                ]),
                _c("vs-th", { key: "status" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.status"))),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c(
                      "vs-td",
                      { key: "select", attrs: { width: "4%" } },
                      [
                        _c("b-form-checkbox", {
                          attrs: {
                            checked: _vm.selected.includes(tr.id),
                            disabled: tr.status === "DO",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggle(tr.id)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("vs-td", { key: "protocol", attrs: { width: "10%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.protocol || "—"))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "establishment", attrs: { width: "15%" } },
                      [_c("div", [_vm._v(_vm._s(tr.establishment_name))])]
                    ),
                    _c("vs-td", { key: "type", attrs: { width: "18%" } }, [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("cancellation.movement_type_." + tr.type)
                            ) +
                            " "
                        ),
                        tr.request && tr.request.reason === "CL"
                          ? _c("span", [_vm._v("· aula cancelada pelo clube")])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("vs-td", { key: "amount", attrs: { width: "10%" } }, [
                      _c("div", [_vm._v(_vm._s(_vm.formatValue(tr.amount)))]),
                    ]),
                    _c("vs-td", { key: "split", attrs: { width: "18%" } }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cancellation.split_." + tr.split_action)
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "age", attrs: { width: "9%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.ageColor(tr.opened_at),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.ageLabel(tr.opened_at)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "16%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.statusColor(tr.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "cancellation.movement_status_." + tr.status
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        tr.failure_reason
                          ? _c("div", { staticClass: "text-danger mt-25" }, [
                              _c("small", [_vm._v(_vm._s(tr.failure_reason))]),
                            ])
                          : tr.gateway_refund_id
                          ? _c("div", { staticClass: "text-muted mt-25" }, [
                              _c("small", [
                                _vm._v(
                                  _vm._s(tr.gateway) +
                                    " · " +
                                    _vm._s(tr.gateway_refund_id)
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }